function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#BFBBB7",
  strokeWidth: 0.825
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.148 3.003v3.82h6.273v-3.82H8.949l-.064-.333c-.158-.81-.842-1.397-1.638-1.397-.795 0-1.48.587-1.637 1.397l-.065.333H4.148z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.667 3.867H3.333c-1.61 0-2.92 1.359-2.92 3.042v8.636c0 1.684 1.31 3.042 2.92 3.042h8.334c1.61 0 2.92-1.358 2.92-3.042V6.91c0-1.683-1.31-3.042-2.92-3.042z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M2.807 12.792l2.316 2.802 7.12-6.009"
}));

var SvgDotAudit = function SvgDotAudit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotAudit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dotAudit.79bdbf9c.svg";
export { ForwardRef as ReactComponent };